import { collection, query, where, limit, getDocs } from 'firebase/firestore';
import { db } from './firebase/firebase';
import store from './productStore';

// Cache en mémoire partagé entre toutes les pages
export const cache = new Map();

const SLUG_TO_CAT = {
  'vetements':    'clothing',
  'chaussures':   'shoes',
  'electronique': 'electronics',
  'jeux-video':   'gaming',
  'laptops':      'laptops',
  'cameras':      'cameras',
  'maison':       'home',
};

async function fetchCat(catValue) {
  const key = catValue || 'all';
  if (cache.has(key)) return;

  const [ebaySnap, userSnap] = await Promise.all([
    getDocs(query(
      collection(db, 'ebay_products'),
      ...(catValue ? [where('category', '==', catValue)] : [where('available', '==', true)]),
      limit(40)
    )),
    getDocs(query(
      collection(db, 'user_products'),
      ...(catValue ? [where('category', '==', catValue)] : []),
      limit(40)
    )),
  ]);

  const ebay  = ebaySnap.docs.map(d => ({ id: d.id, ...d.data(), _col: 'ebay_products', isCreator: false })).filter(p => p.available !== false);
  const users = userSnap.docs.map(d => ({ id: d.id, ...d.data(), _col: 'user_products',  isCreator: true  }));
  cache.set(key, [...users, ...ebay]);
}

// Précharge les produits de la home dans le productStore (pendant le splash)
export async function prefetchHome() {
  if (store.get().length > 0) return; // déjà en mémoire

  const [ebaySnap, userSnap] = await Promise.all([
    getDocs(query(collection(db, 'ebay_products'), where('available', '==', true), limit(40))),
    getDocs(query(collection(db, 'user_products'), limit(40))),
  ]);

  const ebay  = ebaySnap.docs.map(d => ({ id: d.id, ...d.data(), _col: 'ebay_products', isCreator: false }));
  const users = userSnap.docs.map(d => ({ id: d.id, ...d.data(), _col: 'user_products',  isCreator: true  }));

  const byLeastViews = (a, b) => (a.views || 0) - (b.views || 0);
  store.add([
    ...users.sort(byLeastViews),
    ...ebay.sort(byLeastViews),
  ]);
}

// Appelé une fois au démarrage de l'app
export function prefetchAll() {
  prefetchHome().catch(() => {});
  // toutes les catégories en parallèle, silencieusement
  Object.values(SLUG_TO_CAT).forEach(catValue => {
    fetchCat(catValue).catch(() => {});
  });
}
